import { renderFooter } from "../components/footer.js";
import { renderNavbar } from "../components/navbar.js";
import { renderContactPage } from "../pages/contact.js";
import { afterHomeRender, renderHomePage } from "../pages/home.js";
import { renderNotFoundPage } from "../pages/not-found.js";
import { renderTermsPage } from "../pages/terms.js";

const routes = {
  "/": {
    title: "womyn.network | Join Today",
    render: renderHomePage,
    afterRender: afterHomeRender,
  },
  "/contact": {
    title: "womyn.network | Contact Us",
    render: renderContactPage,
  },
  "/terms": {
    title: "womyn.network | Beta Terms",
    render: renderTermsPage,
  },
};

let app;

export function initRouter() {
  app = document.querySelector("#app");

  if (!app) {
    return;
  }

  window.addEventListener("popstate", () => renderCurrentRoute());
  document.addEventListener("click", handleRouteClick);

  renderCurrentRoute();
}

function handleRouteClick(event) {
  const link = event.target.closest("a[data-route]");

  if (!link) {
    return;
  }

  const url = new URL(link.getAttribute("href"), window.location.origin);

  if (url.origin !== window.location.origin) {
    return;
  }

  event.preventDefault();
  history.pushState({}, "", `${url.pathname}${url.hash}`);
  renderCurrentRoute();
}

function renderCurrentRoute() {
  const path = normalizePath(window.location.pathname);
  const route = routes[path] || {
    title: "womyn.network | Page Not Found",
    render: renderNotFoundPage,
  };

  document.title = route.title;
  app.innerHTML = `${renderNavbar()}${route.render()}${renderFooter()}`;

  bindMenuToggle();
  updateActiveNav();
  route.afterRender?.();
  scrollToCurrentHash();
}

function bindMenuToggle() {
  const toggle = document.querySelector(".menu-toggle");
  const menu = document.querySelector("#primaryNav");

  if (!toggle || !menu) {
    return;
  }

  toggle.addEventListener("click", () => {
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!isOpen));
    menu.classList.toggle("is-open", !isOpen);
  });
}

function updateActiveNav() {
  const currentPath = normalizePath(window.location.pathname);
  const currentHash = window.location.hash;
  const navLinks = document.querySelectorAll(".nav-menu a");

  navLinks.forEach((link) => {
    const url = new URL(link.getAttribute("href"), window.location.origin);
    const linkPath = normalizePath(url.pathname);
    const matchesContact = currentPath === "/contact" && linkPath === "/contact";
    const matchesHash = currentPath === "/" && linkPath === "/" && currentHash && url.hash === currentHash;

    link.classList.toggle("is-active", matchesContact || matchesHash);
  });
}

function scrollToCurrentHash() {
  if (!window.location.hash) {
    window.scrollTo({ top: 0, behavior: "auto" });
    return;
  }

  const target = document.querySelector(window.location.hash);

  if (target) {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

function normalizePath(pathname) {
  if (pathname === "/" || pathname === "/index.html") {
    return "/";
  }

  return pathname.replace(/\/$/, "");
}
